// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgm_a bhl_bi"};